import type { NodeProps } from '@xyflow/react';
import { NodeShell } from './nodeShell';

export function CaseNode({ data, selected }: NodeProps) {
  const d = data as { title?: string; citation?: string; holding?: string; vaultLink?: string };
  return (
    <NodeShell title={d.title ?? 'Case'} kind="case" accent="#0033a0" selected={selected}>
      {d.citation && <div style={{ color: '#555' }}>{d.citation}</div>}
      {d.holding && <div style={{ marginTop: 2 }}>{d.holding}</div>}
      {d.vaultLink && <div style={{ marginTop: 2, color: '#0066cc' }}>[[{d.vaultLink}]]</div>}
    </NodeShell>
  );
}
